import { render, staticRenderFns } from "./EWUserActivityLimitList.vue?vue&type=template&id=56a1c4c4&"
import script from "./EWUserActivityLimitList.vue?vue&type=script&lang=js&"
export * from "./EWUserActivityLimitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports